import { render, staticRenderFns } from "./DialogueForm.vue?vue&type=template&id=9b09f9a4&"
import script from "./DialogueForm.vue?vue&type=script&lang=js&"
export * from "./DialogueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports